import React, { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CheckIcon from "@mui/icons-material/Check";

function TreatmentDrop({ data, onChange, name, label }: any) {
  const [open, setopen] = useState(false);
  const [selected, setselected] = useState("Select");

  const onHandelChange = (e: any) => {
    onChange({
      target: {
        name: name,
        value: e.value,
      },
    });
    setopen(false);
    setselected(e.treatment);
  };

  return (
    <div className="relative">
      <label className="block text-sm font-medium text-slate-700 mb-1.5 capitalize">{label}</label>
      <button
        type="button"
        onClick={() => setopen((prev) => !prev)}
        className="w-full px-4 py-2.5 rounded-xl border border-gray-600 border-solid bg-slate-50 text-left flex items-center justify-between focus:outline-none transition-all"
      >
        <span className={selected === "Select" ? "text-slate-400" : "text-slate-800 font-medium"}>
          {selected}
        </span>
        <KeyboardArrowDownIcon
          className={`text-slate-400 transition-transform ${open ? "rotate-180" : ""}`}
          sx={{ fontSize: 20 }}
        />
      </button>

      {open && (
        <ul className="absolute z-20 w-full mt-1 bg-white border border-slate-200 rounded-xl shadow-xl max-h-64 overflow-y-auto">
          <li
            onClick={() => onHandelChange({ value: "", treatment: "Select" })}
            className="px-4 py-2.5 hover:bg-slate-50 cursor-pointer text-sm text-slate-500 border-b border-slate-100"
          >
            Select
          </li>
          {data?.map((item: any, i: number) => (
            <li
              key={i}
              onClick={() =>
                onHandelChange({
                  value: item._id + "/" + item.treatment + "/" + item.price,
                  treatment: item.treatment,
                })
              }
              className={`px-4 py-2.5 cursor-pointer flex items-center justify-between border-b border-slate-100 last:border-0 transition-colors ${
                selected === item.treatment
                  ? "bg-indigo-50 text-indigo-700"
                  : "hover:bg-slate-50 text-slate-700"
              }`}
            >
              <span className="text-sm font-medium">{item.treatment}</span>
              <div className="flex items-center gap-2">
                <span className="text-xs px-2 py-0.5 bg-emerald-100 text-emerald-700 rounded-full font-semibold">
                  Rs {item.price}
                </span>
                {selected === item.treatment && (
                  <CheckIcon className="text-indigo-600" sx={{ fontSize: 18 }} />
                )}
              </div>
            </li>
          ))}
          <li
            onClick={() => onHandelChange({ value: "others", treatment: "Others" })}
            className={`px-4 py-2.5 cursor-pointer flex items-center justify-between transition-colors ${
              selected === "Others"
                ? "bg-amber-50 text-amber-700"
                : "hover:bg-slate-50 text-slate-600"
            }`}
          >
            <span className="text-sm font-medium italic">+ Others (Custom)</span>
            {selected === "Others" && (
              <CheckIcon className="text-amber-600" sx={{ fontSize: 18 }} />
            )}
          </li>
        </ul>
      )}
    </div>
  );
}

export default TreatmentDrop;
